// const Bind = () => import(/* webpackChunkName: "bind" */'@/pages/customer/Bind');

import Appointment from '@/pages/scheduler/Appointment'
import Scheduler from '@/pages/scheduler/Scheduler'
import All from '@/pages/scheduler/All'
import Applying from '@/pages/scheduler/Applying'
import Waiting from '@/pages/scheduler/Waiting'
import NotArrangement from '@/pages/scheduler/NotArrangement'
import Done from '@/pages/scheduler/Done'

export default [
  {
    name: 'appointment',
    path: '/appointment',
    component: Appointment,
    meta: {
      title: '预约申请'
    }
  },
  {
    // name: 'scheduler',
    path: '/scheduler',
    component: Scheduler,
    meta: {
      title: '我的预约'
    },
    children:[
      {
        path:'/',
        redirect: 'all'
      },{
        path:'all',
        name:'all',
        component: All,
        meta: {
          title: '全部预约'
        },
      },{
        path:'applying',
        name:'applying',
        component: Applying,
        meta: {
          title: '申请中预约'
        },
      },{
        path:'waiting',
        name:'waiting',
        component: Waiting,
        meta: {
          title: '待做预约'
        },
      },{
        path:'notArrangement',
        name:'notArrangement',
        component: NotArrangement,
        meta: {
          title: '未排上预约'
        },
      },{
        path:'done',
        name:'done',
        component: Done,
        meta: {
          title: '已做预约'
        },
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/scheduler.js